export const TIME_LINE_LEFT_MARGIN = 8;
